import { useEffect, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import { useTranslation } from "react-i18next";

import RegistrationForm from "./sections/RegistrationForm";
import AuthBackButton from "@/my_components/_Login/sections/AuthBackButton";
import DarkSwitch from "@/my_components/Header/dark-switch";
import { useAppContext } from "@/context/Context";
import { getPlatformStats } from "@/services/courseService";
import { ROUTE } from "@/route/app_routes.js";

import logoWhite from "../../public/images/logo/smarttech-full-white.png";
import logo from "../../public/images/logo/smarttech-full-blue.png";
import logoLight from "../../public/images/logo/smarttech-full-white.png";
import formPanelPhoto from "../../public/app_images/about/about_us.webp";

const Register = () => {
  const { isLightTheme, toggleTheme } = useAppContext();
  const { t } = useTranslation();
  const [stats, setStats] = useState(null);

  const FEATURES = [
    t("auth.register.hero.featureFree"),
    t("auth.register.hero.featureCertificate"),
    t("auth.register.hero.featureInstructors"),
  ];

  useEffect(() => {
    getPlatformStats()
      .then((res) => setStats(res.data))
      .catch(() => {});
  }, []);

  return (
    <>
      <DarkSwitch isLight={isLightTheme} switchTheme={toggleTheme} />
      <AuthBackButton />

      <div className="rbt-auth-split rbt-auth-split--reverse">
        <div className="rbt-auth-split__brand">
          <span className="rbt-auth-split__brand-bg" aria-hidden="true" />
          <span className="rbt-auth-split__brand-dots" aria-hidden="true" />
          <span className="rbt-auth-split__brand-glow" aria-hidden="true" />

          <div className="rbt-auth-split__brand-inner">
            <Link href={ROUTE.home} className="rbt-auth-split__logo">
              <Image src={logoWhite} width={210} height={80} priority alt={t("auth.register.hero.logoAlt")} />
            </Link>

            <h2 className="rbt-auth-split__headline">{t("auth.register.hero.headline")}</h2>
            <p className="rbt-auth-split__sub">
              {t("auth.register.hero.subParagraph")}
            </p>

            <ul className="rbt-auth-split__features">
              {FEATURES.map((feature) => (
                <li key={feature}>
                  <i className="feather-check-circle"></i> {feature}
                </li>
              ))}
            </ul>

            {stats && (
              <div className="rbt-hero-stats">
                <div className="rbt-hero-stats__item">
                  <span className="rbt-hero-stats__value">{stats.total_courses}+</span>
                  <span className="rbt-hero-stats__label">{t("auth.register.hero.statsFreeCourses")}</span>
                </div>
                <div className="rbt-hero-stats__item">
                  <span className="rbt-hero-stats__value">{stats.total_students}+</span>
                  <span className="rbt-hero-stats__label">{t("auth.register.hero.statsStudents")}</span>
                </div>
                <div className="rbt-hero-stats__item">
                  <span className="rbt-hero-stats__value">{stats.total_instructors}+</span>
                  <span className="rbt-hero-stats__label">{t("auth.register.hero.statsInstructors")}</span>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="rbt-auth-split__form-panel">
          <div className="rbt-auth-split__form-panel-bg" aria-hidden="true">
            <Image src={formPanelPhoto} alt="" fill sizes="100vw" style={{ objectPosition: "center 20%" }} priority />
          </div>
          <span className="rbt-auth-split__form-panel-scrim" aria-hidden="true" />

          <div className="rbt-auth-split__form-topbar">
            <Link href={ROUTE.home} className="rbt-auth-split__mobile-logo">
              <Image src={isLightTheme ? logo : logoLight} width={158} height={60} priority alt={t("auth.register.hero.logoAlt")} />
            </Link>
            <span className="rbt-auth-split__signup-hint">
              {t("auth.alreadyHaveAccount")} <Link href={ROUTE.login}>{t("auth.signIn")}</Link>
            </span>
          </div>

          <div className="rbt-auth-split__form-wrap">
            <RegistrationForm />
          </div>
        </div>
      </div>
    </>
  );
};

export default Register;
